import { RICH_TEXT_BLOCK_TYPE } from '@fox/blocks';
import { nanoid } from 'nanoid';
import { SECTION_BLOCK_TYPE, SECTION_DROP_PANEL_TYPE } from '../../../form-block-types';

const DEFAULT_FINAL_PAGE_MESSAGE = 'Your submission has been processed';

export const generateFormFinalPage = (contents: string = DEFAULT_FINAL_PAGE_MESSAGE) => {
	return {
		id: 'finalpage',
		props: {
			innerLayout: {
				layouts: [
					{
						id: 'droppanel_finalpage',
						props: {
							columnContents: [
								{
									items: [
										{
											columnIndex: 0,
											id: nanoid(),
											props: {
												contents: {
													content: [
														{
															type: 'paragraph',
															attrs: { textAlign: 'center' },
															content: [
																{
																	text: contents,
																	type: 'text'
																}
															]
														}
													],
													type: 'doc'
												}
											},
											type: RICH_TEXT_BLOCK_TYPE
										}
									],
									columnIndex: 0
								}
							],
							columns: [
								{
									width: '100%'
								}
							]
						},
						type: SECTION_DROP_PANEL_TYPE
					}
				]
			},
			title: 'finalpage'
		},
		type: SECTION_BLOCK_TYPE
	};
};

export const DEFAULT_FINAL_FORM_PAGE = generateFormFinalPage();
